import { useScanDeviceApiDetailQuery } from '@hooks/api/useScanDeviceApiDetailQuery';
import type { VrsType } from 'types/api';

export const useVrsType = useScanDeviceApiDetailQuery<VrsType>('/vrs-types');
